export default __webpack_public_path__ + "static/media/item_3.51d69b9f.webp";